import React from "react";
import Internship from "./Internship";
import Work from "./Work";

function Experience() {
  return (
    <div>
      <div className="">
        <div className="">
          <Work />
        </div>
        <div className="">
          <Internship />
        </div>
      </div>
    </div>
  );
}

export default Experience;
